<template>
  <label class="button__radio-label_container">
    <input
      :checked="checked"
      :value="text"
      class="button__radio-input radio-input"
      type="radio"
    >
    <RadioBorder/>
    <span
      v-if="text"
      class="button__radio-label choice"
      v-text="text"
    />
  </label>

</template>

<script>
  import RadioBorder from '@/components/RadioBorder';

  export default {
    name: 'ChoiceButton',
    components: {
      RadioBorder,
    },
    props: {
      image: {
        type: String,
        default: null,
      },
      checked: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>
<style lang="scss">
.button__radio-label_container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    border: $radio-border-size solid $gray;
    border-radius: $global-border-radius;

    @include breakpoint(medium) {
        width: 170px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ChoiceButton.vue